// Components/ui
import { Phone } from './components';
import { SubsectionBodyContainer } from '../../../../layout';
// Types
import { NewAddress } from '../../../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  phoneNumbers: Array<NewAddress | IContactAddress>;
};

const Body = ({ phoneNumbers }: Props) => {
  return (
    <SubsectionBodyContainer variant="large">
      {phoneNumbers?.map((phone) => (
        <Phone key={phone.id} data={phone} />
      ))}
    </SubsectionBodyContainer>
  );
};

export default Body;
